import type { LC_GetCustomRolesCatalogOut, CustomRoleCatalog } from './customRoles.types';


export const mapCustomRolesCatalog = (out: LC_GetCustomRolesCatalogOut): CustomRoleCatalog[] => {
  if (!out?.length) return [];
  return out.map((item) => ({
    id: item.rolId,
    description: item.rolName || '',
  }));
};
